import React, { useEffect, useState } from "react";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar, Typography } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import InfoInput from "../../atoms/InfoInput";
import { updateSurvey } from "../../../api/services/services";
import MuiAlert from "@mui/material/Alert";
import { getSingleSurvey } from "../../../api/services/services";
import { initiateSurvey } from "../../../api/services/services";
import TextField from "@mui/material/TextField";
import "./style.css";

const InitiateSurvey = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", description: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const handleSubmit = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(formData?.email)) {
      setIsLoading(true);
      initiateSurvey(formData).then(() => {
        setSnackbarMessage("Shipment request submitted successfully!");
        setOpenSnackbar(true);
        setTimeout(() => navigate("/"), 1500);
      }).catch((error) => {
        setIsLoading(false);
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear(); window.location.pathname = "/login";
        } else {
          setSnackbarMessage(error?.response?.data?.message); setOpenSnackbar(true);
        }
      });
    } else setShowEmailError(true);
  };

  const disableSubmit = !formData.name.trim() || !formData.email.trim() || !formData.phone.trim() || !formData.description.trim();

  return (
    <>
      <MainTemplate>
        <div className="page-header-container d-flex align-items-center">
            <div className="d-flex align-items-center">
                <div className="back-bg cursor-pointer me-3" onClick={() => navigate(-1)} style={{ background: 'rgba(0,0,0,0.03)', padding: '8px', borderRadius: '12px' }}>
                    <img src={backArrow} height="20" width="20" alt="Back" />
                </div>
                <div>
                   <h1 className="page-title">Shipment Request</h1>
                   <p className="page-subtitle">Initiate a new logistics workflow for a client</p>
                </div>
            </div>
            <div className="ms-auto">
                <button className="btn-premium" disabled={disableSubmit || isLoading} onClick={handleSubmit}>
                    {isLoading ? "Processing..." : "Submit Request"}
                </button>
            </div>
        </div>

        <div className="glass-card p-4 p-md-5 mx-auto" style={{ maxWidth: '1000px' }}>
          <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
            <div className="survey-section-title">Client Information</div>
            
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <label className="premium-label">Client Name</label>
                <InfoInput type="text" value={formData.name} placeholder="e.g. John Doe"
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  name={"Name"} inline={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <label className="premium-label">Email Address</label>
                <InfoInput type="text" value={formData.email} placeholder="client@example.com"
                  onChange={(e) => { setFormData({ ...formData, email: e.target.value }); setShowEmailError(false); }}
                  name={"Email"} inline={{ width: "100%" }}
                />
                {showEmailError && <p className="text-danger small mt-1 fw-bold">Please enter a valid email address</p>}
              </Grid>

              <Grid item xs={12} sm={6}>
                <label className="premium-label">Phone Number</label>
                <InfoInput type="number" value={formData.phone} placeholder="+1 (555) 000-0000"
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  name={"Phone"} inline={{ width: "100%" }}
                />
              </Grid>

              <Grid item xs={12}>
                <div className="survey-section-title mt-4">Detailed Requirements</div>
                <label className="premium-label">Description & Special Instructions</label>
                <TextField
                  rows={6}
                  placeholder="Describe cargo type, quantity, deadline, or any special handling requirements..."
                  fullWidth
                  value={formData?.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  multiline
                  required
                  sx={{
                      '& .MuiOutlinedInput-root': {
                          background: 'rgba(241, 245, 249, 0.4)',
                          borderRadius: '16px',
                          border: '1px solid rgba(0,0,0,0.03)',
                          padding: '16px',
                          fontSize: '0.95rem',
                          transition: 'all 0.3s ease',
                          '&:hover': { background: 'rgba(241, 245, 249, 0.6)' },
                          '&.Mui-focused': { background: 'white', borderColor: 'var(--primary-color)', boxShadow: '0 4px 12px rgba(79, 70, 229, 0.08)' }
                      },
                      '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                  }}
                />
              </Grid>
            </Grid>
          </form>
        </div>
      </MainTemplate>

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <MuiAlert elevation={6} variant="filled" severity={snackbarMessage?.includes("successful") || snackbarMessage?.includes("success") ? "success" : "error"} onClose={handleCloseSnackbar} sx={{ borderRadius: '12px', fontWeight: 600 }}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};
export default InitiateSurvey;
